module.exports = __webpack_public_path__ + "static/media/025-Restaurant Marina Boucherville.f8ead58d.jpg";